// @index(['./**/*.ts', '!./**/*.{spec,test}.ts'], f => `export * from '${f.path}.js'`)
export * from './lib/names/names.js';
export * from './lib/names/normalize-name.js';
export * from './lib/names/pluralize.js';
export * from './lib/names/slugify.js';
export * from './lib/names/to-slug.js';
export * from './lib/names/trim.js';
export * from './lib/resource-names/auth-operation-name.js';
export * from './lib/resource-names/data-model-name.js';
export * from './lib/resource-names/dto-class-name.js';
export * from './lib/resource-names/extract-resource-name.js';
export * from './lib/resource-names/resource-class-name.js';
export * from './lib/resource-names/resource-operation-name.js';
export * from './lib/resource-paths/auth-paths.js';
export * from './lib/resource-paths/resource-paths.js';

